/**
 * @member {Object} token
 * @member {Object} user
 * @member {Object} entity
 */
import { AccessTokenDTO } from './AccessTokenDTO';
import { FileDTO } from './FileDTO';

export class WidgetConstructorDTO {
  constructor ({ success, token, file }) {
    let properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }
    Object.defineProperty(this, 'success', Object.assign({ value: success }, properties));
    Object.defineProperty(this, 'token', Object.assign({ value: new AccessTokenDTO(token) }, properties));
    Object.defineProperty(this, 'file', Object.assign({ value: new FileDTO(file) }, properties));
    Object.freeze(this);
  }
}
